import { z } from "zod";

import { schemes } from "../schema-validation";

export const webhookEvent = z.object({
  entityID: z.string(),
  externalService: z.enum(["treasury-prime", "bullhorn", "astra"]),
  entityType: z.enum([
    "ach",
    "book",
    "card-event",
    "transaction",
    "pay-export-batch",
  ]),
  scope: z.enum(["create", "update"]),
  event: z.any(),
  tags: z.array(z.enum(["cardEvent", "transactionUpdate"])),
  _id: schemes.mongoObjectId(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type WebhookEvent<T = any> = z.infer<typeof webhookEvent> & { event: T };
